import { render, staticRenderFns } from "./FontSelect.vue?vue&type=template&id=353229f4&scoped=true&"
import script from "./FontSelect.vue?vue&type=script&lang=js&"
export * from "./FontSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "353229f4",
  null
  
)

export default component.exports